module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABJUlEQVQ4jZXTOy+EQRSH8Z/dLVwK4lq7bERCJ1Qi0ShFQfSiVGloNAqFUq9Y1YpCJxLxAZRWQsJWbg0bkYhyFTPF643EmGQyZy7/Z86cc6alUqncYAiHWEPTP1oJe5jHaoQU0Jug/cR5CQc4xTJmsY1iogPVUjRe0MAgRtGVIN7AUimzUMM46om3t+KhkFm4RTlRDBOoZQF1dKIvQdwhZO4H4C6OKV6MCdn6AbiP4/Af4jbMRLuWDWJdKKKyUBOT6Mn1brTH81e4yQK+8IgRrKAfb3gV0nwd5w084RjNLIAQh2ls/vEMGMB7HrCPKo4SAJeYzgNO4u0L2MF7br+ALSFW64TPlG2dwucq4gy7uf05LGa8fc4DPqJwChe/uF0TKrYpBNU3NuM9A8i0eYUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/shopping_cart.png
// module id = rDZD
// module chunks = 0